// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"370cafde","455":"cae8a88c"}[chunkId] + ".chunk.js";
};